export const en = {
	signin: "Sign In",
};
